<template>
  <div>
    <div
      class="bulk-action-tray d-flex"
      v-if="selectedCount > 1"
      :data-prevent-multiselect-dimissal="true"
    >
      <div class="count text-extra-extra-large bold flex-center">
        {{ selectedCount }}
      </div>
      <div class="actions d-flex flex-gap-14 mx-auto">
        <div
          class="flex-center flex-column action-item pointer"
          @click="isMoveInitiativeModalShown = true"
        >
          <i class="arrow-circle-icon mb-1"></i>
          <div class="text-medium">Move</div>
        </div>
        <div class="flex-center flex-column action-item pointer" @click="isDeleteModalShown = true">
          <i class="trash-icon mb-1 delete-icon"></i>
          <div class="text-medium">Delete</div>
        </div>
      </div>
    </div>
    <delete-initiatives-modal
      v-model="isDeleteModalShown"
      v-if="isDeleteModalShown"
      :selected-initiatives="selectedInitiatives"
      @done="onActionDone"
    />
    <move-initiative
      v-if="isMoveInitiativeModalShown"
      v-model="isMoveInitiativeModalShown"
      :initiatives="selectedInitiatives"
      @moved="onActionDone"
    />
  </div>
</template>

<script>
import DeleteInitiativesModal from '@/components/initiative/DeleteInitiativesModal.vue'
import MoveInitiative from '@/components/initiative/MoveInitiative.vue'
import events from '@/constants/events'
import EventBusMixin from '@/mixins/EventBusMixin'

/**
 * This shows a tray with bulk actions such as move, delete etc.
 * This gets shown up when multiple initiatives are selected.
 */
export default {
  name: 'BulkActionTray',
  components: { MoveInitiative, DeleteInitiativesModal },
  props: [],
  mixins: [EventBusMixin],
  data() {
    return {
      isDeleteModalShown: false,
      isMoveInitiativeModalShown: false,
      selectedAction: ''
    }
  },
  computed: {
    selectedItems() {
      return this.$store.getters['bulkAction/selectedItems']
    },
    selectedInitiatives() {
      return this.selectedItems.map(id => this.$store.getters.initiativeById(id)).filter(Boolean)
    },
    selectedCount() {
      return this.selectedItems.length
    },
    isModalShown() {
      return this.isDeleteModalShown || this.isMoveInitiativeModalShown
    }
  },
  methods: {
    onActionDone(payload) {
      this.eventBusEmit(events.BULK_ACTION_DONE, payload)
    }
  },
  watch: {
    isModalShown(isShown) {
      this.$store.commit('bulkAction/SET_SELECTION_LOCK', isShown)
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/styles/_styleConfigurations.scss';

.bulk-action-tray {
  position: fixed;
  bottom: 20px;
  z-index: 1000;
  box-shadow: $menuShadow;
  height: 64px;
  width: 255px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 40px;
  padding-right: 25px;
  overflow: hidden;
  background-color: $documentColor;
}

.count {
  background-color: $brand;
  min-width: 70px;
  color: $documentColor;
}

.action-item {
  width: 60px;

  &:hover {
    background-color: $quaternary;
  }
}

.delete-icon {
  @include dimension(20px, 20px);
}
</style>
